import GalleryUploadForm from "./sections/GalleryUploadForm.jsx";
import { createGallery } from "../../api/gallery/uploadModal.js";
/* eslint-disable react-hooks/exhaustive-deps */

import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { useCallback, useEffect, useRef, useState } from "react";


import Resizer from "react-image-file-resizer";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";





const PIXEL_RATIO = 4;
const UploadImageGallery = ({ setAllRows, allRows, setOpen }) => {
  const [crop, setCrop] = useState({
    unit: "%",
    x: 0,
    y: 0,

    aspect: 12 / 12,
    width: 100,
    height: 100,
  });
  const { token } = useSelector((state) => state.user);

  const [src, setSrc] = useState();
  const [filename, setfilename] = useState();
  const [completedCrop, setCompletedCrop] = useState();
  const [croping, setCroping] = useState(false);
  const [resizing, setResizing] = useState(false);
  const [quality, setQuality] = useState(100);
  const [height, setHeight] = useState(500);
  const [ondrag, setOnDrag] = useState(false);

  const [loading, setLoading] = useState(false);
  const [blob, setBlob] = useState();
  const [blobType, setBlobType] = useState("");
  const [preview, setPreview] = useState();
  const [files, setFiles] = useState([]);

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const onLoad = useCallback((img) => {
    /*     imgRef.current = img;
     */
  }, []);
  useEffect(() => {
    if (filename) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setSrc(reader.result));
      reader.readAsDataURL(filename);
    }
  }, [filename]);
  const blobUrlRef = useRef("");

  function onDownloadCropClick() {
    if (!previewCanvasRef.current) {
      throw new Error("Crop canvas does not exist");
    }

    previewCanvasRef.current.toBlob((bl) => {
      if (!bl) {
        throw new Error("Failed to create blob");
      }
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current);
      }

      setBlob(bl);
      blobUrlRef.current = URL.createObjectURL(bl);
      /*    setPreview(blobUrlRef.current); */
    });
  }

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const ctx = canvas.getContext("2d");

    canvas.width = crop.width * PIXEL_RATIO;
    canvas.height = crop.height * PIXEL_RATIO;

    ctx.setTransform(PIXEL_RATIO, 0, 0, PIXEL_RATIO, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    canvas.toBlob((blob) => {
      const previewUrl = URL.createObjectURL(blob);

      setBlob(blob);
      setPreview(previewUrl);
      setBlobType(blob.type);
    }, blobType);
  }, [completedCrop]);

  const resizedCropedImage = (image) => {
    console.log(filename.type === "image/svg+xml", "filename.type");
    if (filename.type === "image/svg+xml" || filename.type === "image/gif") {
      var data = new FormData();
      data.append(
        "files",
        image,
        filename.name?.split(".")[0] +
          (filename.type === "image/svg+xml" ? ".svg" : ".gif")
      );
      uploadImageHandler(data);
    } else {
      if (image !== null) {
        try {
          Resizer.imageFileResizer(
            image,
            Number(height),
            Number(height),
            "webp",
            Number(quality) > 100 ? 100 : Number(quality),
            0,
            (uri) => {
              var data = new FormData();
              data.append("files", uri, filename.name?.split(".")[0] + ".webp");
              uploadImageHandler(data);
            },
            "blob"
          );
        } catch (err) {
          console.log(err);
        }
      }
    }
  };

  const handleUploadImage = () => {
    /*  var bl = blob ? blob : onDownloadCropClick(); */
    if (resizing && croping) {
      resizedCropedImage(blob ? blob : preview);
    } else if (resizing && !croping) {
      resizedCropedImage(preview);
    } else if (!resizing && croping) {
      var data = new FormData();
      data.append("files", blob ? blob : preview);
      uploadImageHandler(data);
    } else {
      resizedCropedImage(preview);
    }
  };
  const uploadMultiple = async () => {
    const resizedFiles = [];

    for (let x = 0; x < files.length; x++) {
      if (files[x].type === "image/svg+xml" || files[x].type === "image/gif") {
        resizedFiles.push(files[x]);
      } else {
        const resizedFile = await new Promise((resolve) => {
          Resizer.imageFileResizer(
            files[x],
            1000,
            1000,
            "webp",
            80,
            0,
            (uri) => {
              resolve(uri);
            },
            "blob"
          );
        });
        resizedFiles.push(resizedFile);
      }
    }

    const fd = new FormData();

    resizedFiles.forEach((file, index) => {
      if (
        files[index].type === "image/svg+xml" ||
        files[index].type === "image/gif"
      ) {
        fd.append(
          "files",
          file,
          files[index].name?.split(".")[0] +
            (files[index].type === "image/svg+xml" ? ".svg" : ".gif")
        );
      } else {
        fd.append("files", file, files[index].name?.split(".")[0] + ".webp");
      }
    });
  };
  const uploadDirect = () => {
    const fd = new FormData();
    for (let x = 0; x < files.length; x++) {
      fd.append("files", files[x]);
    }
    uploadImageHandler(fd);
  };
  const uploadImageHandler = (data) => {
    setLoading(true);
    createGallery(data, token)
      .then((res) => {
        setLoading(false);
        toast.success("با موفقیت آپلود شد");
        var temp = [...allRows];
        temp.unshift(res.data.data);

        setAllRows(temp);
        setOpen(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  return (
    <GalleryUploadForm value={value} handleChange={handleChange} a11yProps={a11yProps} TabPanel={TabPanel} files={files} setFiles={setFiles} loading={loading} uploadDirect={uploadDirect} setOpen={setOpen} setfilename={setfilename} setPreview={setPreview} setOnDrag={setOnDrag} ondrag={ondrag} croping={croping} src={src} filename={filename} crop={crop} setCrop={setCrop} setCompletedCrop={setCompletedCrop} imgRef={imgRef} onLoad={onLoad} previewCanvasRef={previewCanvasRef} setCroping={setCroping} resizing={resizing} setResizing={setResizing} setQuality={setQuality} quality={quality} setHeight={setHeight} height={height} handleUploadImage={handleUploadImage} uploadMultiple={uploadMultiple} />
  );
};
export default UploadImageGallery;
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ px: 3 }}>
          <>{children}</>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
